module.exports = __webpack_public_path__ + "media/keysound.eff80cd3.mp3";